import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  List,
  Avatar,
  ListItemText,
  ListItemAvatar,
  FormControl,
  Button,
  ListItemButton,
  Chip,
  ListItemIcon,
  Menu,
  Checkbox,
  ListItem,
  Slider,
  Breadcrumbs,
  Typography,
  Link as MUILink,
} from "@mui/material";
import { AddCircle, FilterList } from "@mui/icons-material";
import SplitPageView from "../components/SplitPageView";
import ProposalDetailsPage from "./ProposalDetailsPage";
import {
  APIAppointment,
  getAllAppointments,
  getAppointment,
} from "../api/appointments";
import AppointmentDetailsPage from "./AppointmentDetailsPage";
import { APICustomer, getCustomer } from "../api/customers";

function AppointmentListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [appointmentsData, setAppointmentsData] = useState<APIAppointment[]>(
    []
  );
  const [curAppointment, setCurAppointment] = useState<APIAppointment | null>(
    null
  );
  const [curCustomer, setCurCustomer] = useState<APICustomer | null>(null);

  useEffect(() => {
    if (!curAppointment?.customerId) {
      setCurCustomer(null);
    }
    getCustomer(curAppointment?.customerId).then((v) => setCurCustomer(v));
  }, [curAppointment?.customerId]);

  useEffect(() => {
    getAllAppointments().then((v) => setAppointmentsData(v));
    if (!id) {
      setCurAppointment(null);
    } else {
      getAppointment(id).then((v) => setCurAppointment(v));
    }
  }, [id]);

  return (
    <SplitPageView
      pageTitle="Appointments"
      contentList={
        <List style={{ padding: 0 }}>
          <ListItemButton
            component={Link}
            to={`/appointments`}
            style={{ border: "0.5px solid #808080" }}
            selected={id === null}
          >
            <ListItemText primary="New Appointment" />
            <ListItemIcon>
              <AddCircle />
            </ListItemIcon>
          </ListItemButton>
          {appointmentsData.map((appointment) => (
            <ListItemButton
              component={Link}
              to={`/appointments?id=${appointment.id}`}
              key={appointment.id}
              style={{ border: "0.5px solid #808080" }}
              selected={appointment.id === id}
            >
              <ListItemText
                primary={`${appointment.startTime.toLocaleString()} to ${appointment.endTime.toLocaleString()}`}
              />
            </ListItemButton>
          ))}
        </List>
      }
      breadcrumbs={
        id && (
          <Breadcrumbs aria-label="breadcrumb">
            <MUILink
              component={Link}
              underline="hover"
              color="inherit"
              to="/customers"
            >
              Customers
            </MUILink>
            <MUILink
              component={Link}
              underline="hover"
              color="inherit"
              to={`/customers?id=${curCustomer?.id}`}
            >
              {curCustomer?.firstName} {curCustomer?.lastName}
            </MUILink>
            <Typography sx={{ color: "text.primary" }}>Appointment</Typography>
          </Breadcrumbs>
        )
      }
      mainContent={<AppointmentDetailsPage id={id || undefined} />}
    />
  );
}

export default AppointmentListPage;
